import { Link, useMatch } from "react-router-dom";
import { FC } from "react";
import { routePaths } from "router";

const NavbarLink: FC<{ routePath: { path: string; name: string } }> = ({ routePath }) => {
	const isRouteActive = useMatch(routePath.path);
	return (
		<Link
			to={routePath.path}
			className={`${isRouteActive ? "bg-primary" : "bg-transparent"} border border-primary px-3 py-1.5 hover:bg-opacity-80 btn-primary`}
		>
			{routePath.name}
		</Link>
	);
};

const Navbar = () => {
	return (
		<div className="w-full h-full flex items-center space-x-1 justify-between">
			<div className="flex items-center flex-1">
				<div className="text-xl text-transparent bg-gradient-to-r animate-text from-primary to-secondary bg-clip-text rounded px-2 py-1 font-medium mr-4">
					Genius Ordering System
				</div>
			</div>
			<div className="flex space-x-1">
				<NavbarLink routePath={routePaths.ROOT} />
				<NavbarLink routePath={routePaths.ORDERS} />
				<NavbarLink routePath={routePaths.PAST_ORDERS} />
			</div>
		</div>
	);
};
export default Navbar;
